import React from 'react';
import { Switch, Route } from 'react-router-dom';

import ListOrgs from './ListOrgs';
import NewOrg from './NewOrg';
import EditOrg from './EditOrg';

function OrgsPage() {
  return (
    <Switch>
      <Route exact path="/orgs" component={ListOrgs} />
      <Route path="/orgs/new" component={NewOrg} />
      <Route path="/orgs/:id" component={EditOrg} />
    </Switch>
  );
}

export default OrgsPage;
